import React, { useState } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { Menu } from 'lucide-react';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="h-screen flex flex-col bg-[#f0f3f9] overflow-hidden p-3 gap-3">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100">
        <Header />
      </div>

      <div className="flex flex-1 min-h-0 gap-3">
        {/* Sidebar handles desktop vs mobile rendering internally — see Sidebar.tsx. */}
        <Sidebar mobileOpen={mobileMenuOpen} onMobileClose={() => setMobileMenuOpen(false)} />

        <div className="flex-1 flex flex-col bg-white rounded-2xl shadow-sm border border-gray-100 overflow-y-auto min-h-0">
          {/* Mobile hamburger */}
          <div className="md:hidden flex items-center px-5 pt-4">
            <button
              onClick={() => setMobileMenuOpen(true)}
              className="w-10 h-10 flex items-center justify-center text-secondary-500 hover:bg-gray-100 hover:text-secondary-700 rounded-xl transition-colors"
            >
              <Menu size={22} />
            </button>
          </div>

          <main className="flex-1 flex flex-col p-5 lg:p-6">
            {children}
          </main>
        </div>
      </div>

      {/* Powered by badge */}
      <div className="fixed bottom-5 right-5 z-50 flex items-center gap-1.5 bg-white/90 backdrop-blur-sm border border-gray-200 rounded-full px-3 py-1.5 shadow-md">
        <span className="text-[11px] text-secondary-400">Powered by</span>
        <img src="/logo.png" alt="TeamCare" className="h-4 w-4 object-contain" />
        <span className="text-[11px] font-semibold text-secondary-600">TeamCare</span>
      </div>
    </div>
  );
};
